<template>
  <div ref="home-page">
    <h5 v-if="filteredCategoryNames.length" class="mb-3">
      <b>Selected categories:</b>
    </h5>

    <div class="flex flex-wrap mb-4">
      <div
        class="badge badge-normal mr-2 mb-2"
        v-for="category in filteredCategoryNames"
        :key="category.id"
      >
        {{ category.name }}
      </div>
    </div>

    <ProductList
      :productList="getProductList()"
      :page="currentPage"
      :isFetching="isFetching"
      :totalPages="getTotalPages()"
      :sortOrder="filters.order"
      :sortBy="filters.orderby"
      @order-change="handleOrderChange"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import ProductList from "@/components/ProductList";
import { createNamespacedHelpers } from "vuex";

const productsMapper = createNamespacedHelpers("products");
const categoriesMapper = createNamespacedHelpers("categories");

export default {
  name: "ProductListPage",
  components: {
    ProductList,
  },
  data() {
    return {
      currentPage: 1,
      productList: [],
    };
  },
  methods: {
    handlePageChange(e) {
      this.$router.push({
        name: this.$route.name,
        query: {
          product_page: e,
        },
      });

      this.$refs["home-page"].scrollIntoView({
        behavior: "smooth",
      });

      this.currentPage = e;
      if (
        !this.filteredProducts?.length &&
        !this.getProductList()[this.currentPage - 1]?.length
      ) {
        this.getProducts(e);
      } else if (
        this.filteredProducts?.length &&
        !this.getProductList()[this.currentPage - 1]?.length
      ) {
        this.getFilteredProducts({
          page: this.currentPage,
        });
      }
    },
    ...productsMapper.mapActions({
      getFilteredProducts: "getFilteredProducts",
      getProducts: "getProducts",
    }),

    handleOrderChange(e) {
      this.$store.commit("products/setFilters", { ...this.filters, ...e });
      this.getFilteredProducts({
        filters: {
          ...e,
        },
      });
    },

    getProductList() {
      return this.filteredProductsPageCount >= 0
        ? this.filteredProducts
        : this.products;
    },

    getTotalPages() {
      return this.filteredProductsPageCount >= 0
        ? this.filteredProductsPageCount
        : this.productsPageCount;
    },
    scrollToSection() {
      var element = document.getElementById("app");
      var headerOffset = 250;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
  },
  computed: {
    ...productsMapper.mapGetters({
      products: "products",
      filteredProducts: "filteredProducts",
      productsPageCount: "productsPages",
      filteredProductsPageCount: "filteredProductsPages",
      filters: "filters",
      isFetching: "isFetching",
    }),

    ...categoriesMapper.mapGetters({
      categories: "categories",
    }),

    filteredCategoryNames() {
      return (
        this.filters?.categories?.map((catId) =>
          this.categories.find((cat) => cat.id == catId)
        ) || []
      );
    },
  },

  watch: {
    filters: {
      handler() {
        this.scrollToSection();
        this.currentPage = 1;
      },
      deep: true,
      immediate: true,
    },

    isFetching(oldVal, newVal) {
      if (!oldVal && newVal) {
        this.scrollToSection();
      }
    },
  },

  mounted() {
    const queryPage = +this.$route.query?.product_page || 1;
    const totalPages = this.getTotalPages();
    if (queryPage > totalPages && queryPage !== 1) {
      this.$router.push({
        name: this.$route.name,
        query: {
          product_page: 1,
        },
      });
    } else {
      this.currentPage = queryPage;
    }
  },
};
</script>

<style></style>
